module.exports = __webpack_public_path__ + "01_short_brown.bf18c2be.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_short_brown.png
// module id = GhQv
// module chunks = 0